import styled from "styled-components";
import materialUI from "../../../../../material-UI";
import colors from "../../../../../constants/color";

export const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  padding: 0 1rem;
  gap: 1rem;
`;

export const Title = styled.div`
  font-family: Inter;
  font-size: 24px;
  font-weight: 400;
  line-height: 29px;
  letter-spacing: -0.01em;
  text-align: left;
  color: #000000de;
`;

export const SubTitle = styled.div`
  font-family: Inter;
  font-size: 13px;
  font-weight: 400;
  line-height: 16px;
  letter-spacing: -0.01em;
  text-align: left;
  color: #00000099;
`;

export const CardResponsaveisContainer = styled.div`
  width: 100%;
  display: flex;
  gap: 1rem;
`;

export const CardResponsaveis = styled.div`
  width: 50%;
  display: flex;
  align-items: center;
  gap: 1rem;

  background-color: #f2f4f8;
  padding: 24px;
  border-radius: 8px;
  box-shadow: rgba(0, 0, 0, 0.15) 1.95px 1.95px 2.6px;
  transition: 0.5s linear;
  &:hover {
    transition: 0.5s linear;
    box-shadow: none;
  }
`;

export const CardResponsaveisImg = styled.img`
  width: 64px;
  height: 64px;
  background-color: #f2f4f8;
  border-radius: 50%;
  box-shadow: rgba(0, 0, 0, 0.15) 1.95px 1.95px 2.6px;
  transition: 0.5s linear;
  &:hover {
    transition: 0.5s linear;
    box-shadow: none;
  }
`;

export const BodyTable = styled.div`
  width: 100%;
  margin-top: 1rem;
`;

export const HeaderTable = styled.div`
  border-radius: 8px;
  display: flex;
  justify-content: space-between;
  flex-direction: row;
  align-items: center;
  padding: 16px 24px;

  height: 56px;
  margin-bottom: 25px;

  background-color: rgba(0, 0, 0, 0.04);
  p {
    white-space: nowrap;
    font-family: "Inter";
    font-style: normal;
    font-weight: 400;
    font-size: 1rem;
    line-height: 150%;
    display: flex;
    align-items: center;
    color: rgba(0, 0, 0, 0.87);
  }
  font-size: 14px;
  .col-1 {
    flex-basis: 34%;
  }
  .col-2 {
    flex-basis: 24%;
  }
  .col-3 {
    flex-basis: 54%;
  }
`;

export const ItemTable = styled.div`
  border-radius: 3px;
  padding: 25px 30px;
  display: flex;
  justify-content: space-between;
  margin-bottom: 25px;
  box-shadow: 0px 0px 9px 0px rgba(0, 0, 0, 0.1);
`;

export const ItemsList = styled.div`
  max-height: 55vh;
  width: 100%;

  &::-webkit-scrollbar {
    width: 5px;
  }

  &::-webkit-scrollbar-track {
    background: #f1f1f1;
  }

  &::-webkit-scrollbar-thumb {
    background: #d5d5d5;
  }
`;

export const Item = styled.div`
  border-radius: 8px;
  display: flex;
  justify-content: space-between;
  flex-direction: row;
  align-items: center;
  padding: 16px 24px;

  height: 56px;
  margin-bottom: 16px;

  background-color: #ffffff;
  border: 1.75px #ececec solid;
  p {
    white-space: nowrap;
    font-family: "Inter";
    font-style: normal;
    font-weight: 400;
    font-size: 1rem;
    line-height: 150%;
    display: flex;
    align-items: center;
    color: rgba(0, 0, 0, 0.87);
  }
  font-size: 14px;
  .col-1 {
    flex-basis: 34%;
  }
  .col-2 {
    flex-basis: 24%;
  }
  .col-3 {
    flex-basis: 54%;
  }
`;

export const Autocomplete = styled(materialUI.Autocomplete)`
  overflow: hidden;
`;

export const LabelText = styled.span`
  display: block;
  font-size: 14px;
  line-height: 150%;
  color: #333333;
  font-family: Inter-Medium;
  margin-bottom: 5px;
`;

export const TextField = styled(materialUI.TextField)`
  margin-top: 2px;
  label {
    display: none;
  }
  legend {
    span {
      display: none;
    }
  }
  .MuiInputBase-adornedEnd {
    height: 44px;
  }
  .MuiInputBase-root {
    border-radius: 8px;
    .MuiAutocomplete-input {
      padding: 4.5px 4px;
    }
  }
  .Mui-focused {
    fieldset {
      border-color: ${colors.primary} !important;
    }
  }
  &.input-disabled {
    background-color: ${colors.gray100};
    input {
      color: ${colors.grey1};
    }
  }
  textarea {
    position: relative;
    &::-webkit-scrollbar {
      width: 5px;
    }

    &::-webkit-scrollbar-track {
      background: #f1f1f1;
    }

    &::-webkit-scrollbar-thumb {
      background: ${colors.LigthGrey};
    }
  }
`;

export const ButtonSend = styled.button`
  width: 100%;
  height: 50px;
  background-color: #2d5bff;
  color: #eaefff;
  border-radius: 8px;
  box-shadow: rgba(0, 0, 0, 0.15) 2.4px 2.4px 3.2px;
  transition: 0.5s linear;
  display: flex;
  justify-content: center;
  align-items: center;
  font-family: Inter;
  font-size: 16px;
  font-weight: 400;
  line-height: 19px;
  letter-spacing: -0.01em;
  text-align: left;

  &:hover {
    cursor: pointer;
    transition: 0.5s linear;
    box-shadow: none;
  }
`;

export const ButtonTransfer = styled.button`
  width: 100%;
  height: 50px;
  background: linear-gradient(to right, #4a76fb, #06d986) !important;
  color: #fff;
  border-radius: 8px;
  transition: 0.5s linear;
  display: flex;
  justify-content: center;
  align-items: center;
  font-family: Inter;
  font-size: 16px;
  font-weight: 400;
  line-height: 19px;
  letter-spacing: -0.01em;
  text-align: left;

  &:hover {
    cursor: pointer;
    transition: 0.5s linear;
    box-shadow: none;
  }
`;

export const CountText = styled.span`
  font-family: Inter;
  font-style: normal;
  font-weight: 400;
  font-size: 13px;
  line-height: 16px;
  color: ${colors.grey1};
  background: ${colors.White};
  position: absolute;
  right: 20px;
  bottom: 10px;
`;
